/*
 *  I13VENTCHAUFBOISReducer.ts
 *
 *  Created by Sébastien Hecart on 2022-08-12 12:25:09 +0000.
 *  Copyright © 2022 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

import { I13VENTCHAUFBOIS_State } from '@batical/types/src'

const I13VENTCHAUFBOIS: I13VENTCHAUFBOIS_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  in_puissanceh_chaufferie: 100.0,
  lowOpen_uuid: 'carre',
  in_longeur_basse: 10.0,
  highOpen_uuid: 'carre',
  in_longeur_haute: 10.0,
  res_ventil_basse: 10.0,
  res_ventil_haute: 10.0,
  res_lowOpen: 10.0,
  res_highOpen: 10.0,
  mode: 'none',
  calcul_code: 'I13VENTCHAUFBOIS'
}

export default I13VENTCHAUFBOIS
